export const redirect = (button: HTMLButtonElement) => {
  const attributeUrl = button.attributes.getNamedItem('data-url');

  if (attributeUrl) {
    setTimeout(() => {
      window.location.href = attributeUrl.value;
    }, 250);
  }
};
